// // frontend/src/features/citysense/housing-stock-modeller/constants/housingConfig.ts

// import { HousingArchetype, DeprivationLevel } from "../types";

// // Retrofit costs and GHG savings by age class (from requirements)
// export const RETROFIT_DATA: Record<
//   string,
//   { cost: number; annualGHG: number; twentyYear: number }
// > = {
//   "Pre-1945": { cost: 75000, annualGHG: 6.2, twentyYear: 124 },
//   "1945-1969": { cost: 62000, annualGHG: 5.0, twentyYear: 100 },
//   "1970-1989": { cost: 52000, annualGHG: 4.0, twentyYear: 80 },
//   "1990-1999": { cost: 42000, annualGHG: 2.8, twentyYear: 56 },
//   "2000-2010": { cost: 32000, annualGHG: 1.9, twentyYear: 38 },
//   "Post-2010": { cost: 18000, annualGHG: 0.8, twentyYear: 16 },
// };

// // Map cluster names to age groups
// export function extractAgeClass(clusterName: string): string {
//   if (!clusterName) return "Post-2010";

//   if (clusterName.includes("Pre-1945") || clusterName.includes("pre-1945"))
//     return "Pre-1945";
//   if (clusterName.includes("1946") || clusterName.includes("1980"))
//     return "1945-1969";
//   if (clusterName.includes("1970") || clusterName.includes("1989"))
//     return "1970-1989";
//   if (clusterName.includes("1990") || clusterName.includes("1999"))
//     return "1990-1999";
//   if (clusterName.includes("2000") || clusterName.includes("2010"))
//     return "2000-2010";
//   if (clusterName.includes("Post-2000") || clusterName.includes("post-2000"))
//     return "Post-2010";

//   return "Post-2010"; // Default to modern
// }

// // Deprivation Index levels with color ramp (blue -> purple)
// export const DEPRIVATION_LEVELS: Record<string, DeprivationLevel> = {
//   "Very Disadvantaged": {
//     label: "Very Disadvantaged",
//     fill: "#3B82F6",
//     order: 1,
//   },
//   Disadvantaged: { label: "Disadvantaged", fill: "#10B981", order: 2 },
//   "Marginally Below Average": {
//     label: "Marginally Below Average",
//     fill: "#FBBF24",
//     order: 3,
//   },
//   "Marginally Above Average": {
//     label: "Marginally Above Average",
//     fill: "#F97316",
//     order: 4,
//   },
//   Affluent: { label: "Affluent", fill: "#EF4444", order: 5 },
//   "Very Affluent": { label: "Very Affluent", fill: "#A855F7", order: 6 },
// };

// // Generate random vibrant colors for archetypes
// const ARCHETYPE_COLORS = [
//   "#FF6B6B",
//   "#4ECDC4",
//   "#45B7D1",
//   "#FFA07A",
//   "#98D8C8",
//   "#F7DC6F",
//   "#BB8FCE",
//   "#85C1E2",
//   "#F8B88B",
//   "#C39BD3",
//   "#7DCEA0",
//   "#FAD7A0",
//   "#AED6F1",
//   "#F5B7B1",
//   "#D7BDE2",
//   "#A2D9CE",
//   "#F9E79F",
//   "#D5DBDB",
//   "#FADBD8",
//   "#D1F2EB",
// ];

// let colorIndex = 0;
// export function getArchetypeColor(): string {
//   const color = ARCHETYPE_COLORS[colorIndex % ARCHETYPE_COLORS.length];
//   colorIndex++;
//   return color;
// }

// export function resetColorIndex() {
//   colorIndex = 0;
// }

// // Map dimensions for EPSG:2157 (Irish Transverse Mercator)
// export const MAP_SIZE = 2000;


// ======================================================================
// ======================================================================
// ======================================================================
// ======================================================================
// ======================================================================
// ======================================================================
// ======================================================================

// frontend/src/features/citysense/housing-stock-modeller/constants/housingConfig.ts

import { HousingArchetype, DeprivationLevel } from "../types";

// Retrofit costs and GHG savings by age class (from requirements)
export const RETROFIT_DATA: Record<
  string,
  { cost: number; annualGHG: number; twentyYear: number }
> = {
  "Pre-1945": { cost: 75000, annualGHG: 6.2, twentyYear: 124 },
  "1945-1969": { cost: 62000, annualGHG: 5.0, twentyYear: 100 },
  "1970-1989": { cost: 52000, annualGHG: 4.0, twentyYear: 80 },
  "1990-1999": { cost: 42000, annualGHG: 2.8, twentyYear: 56 },
  "2000-2010": { cost: 32000, annualGHG: 1.9, twentyYear: 38 },
  "Post-2010": { cost: 18000, annualGHG: 0.8, twentyYear: 16 },
};

// Map cluster names to age groups
export function extractAgeClass(clusterName: string): string {
  if (!clusterName) return "Post-2010";

  if (clusterName.includes("Pre-1945") || clusterName.includes("pre-1945"))
    return "Pre-1945";
  if (clusterName.includes("1946") || clusterName.includes("1980"))
    return "1945-1969";
  if (clusterName.includes("1970") || clusterName.includes("1989"))
    return "1970-1989";
  if (clusterName.includes("1990") || clusterName.includes("1999"))
    return "1990-1999";
  if (clusterName.includes("2000") || clusterName.includes("2010"))
    return "2000-2010";
  if (clusterName.includes("Post-2000") || clusterName.includes("post-2000"))
    return "Post-2010";

  return "Post-2010"; // Default to modern
}

// Deprivation Index levels with color ramp (blue -> purple)
export const DEPRIVATION_LEVELS: Record<string, DeprivationLevel> = {
  "Very Disadvantaged": {
    label: "Very Disadvantaged",
    fill: "#3B82F6",
    order: 1,
  },
  Disadvantaged: { label: "Disadvantaged", fill: "#10B981", order: 2 },
  "Marginally Below Average": {
    label: "Marginally Below Average",
    fill: "#FBBF24",
    order: 3,
  },
  "Marginally Above Average": {
    label: "Marginally Above Average",
    fill: "#F97316",
    order: 4,
  },
  Affluent: { label: "Affluent", fill: "#EF4444", order: 5 },
  "Very Affluent": { label: "Very Affluent", fill: "#A855F7", order: 6 },
};

// ===== FIXED COLORS FROM MAP LEGEND =====
// Specific colors for known archetypes (from your images)
const FIXED_ARCHETYPE_COLORS: Record<string, string> = {
  // Post-war Large Gas houses
  'Post war Large Gas houses': '#B53534',
  
  // Late 1980s Electric houses
  'Late 1980s M Electric houses': '#7AB6F5',
  'Late 1980s M Gas houses': '#7B8EF5',
  
  // Old houses
  'Old Medium Gas houses': '#F6C568',
  'Old Electric Appartments': '#004DA7',
  
  // Modern houses
  'Modern Medium Elect houses': '#A9DDB6',
  'Modern Medium Gas houses': '#89CD66',
  
  // Post-war mix
  'Post war Mix M Gas houses': '#FE0000',
  'Post war M Gas houses-2': '#FF7F7E',
};

// Helper function to match partial archetype names
function getFixedColor(archetypeName: string): string | null {
  // Direct match first
  if (FIXED_ARCHETYPE_COLORS[archetypeName]) {
    return FIXED_ARCHETYPE_COLORS[archetypeName];
  }
  
  // Partial matching for GeoJSON names like "1946–1980 – Natural gas – Large (6+ rooms)"
  const lowerName = archetypeName.toLowerCase();
  
  if (lowerName.includes('post') && lowerName.includes('large') && lowerName.includes('gas')) {
    return '#B53534';
  }
  if (lowerName.includes('1980') && lowerName.includes('electric')) {
    return '#7AB6F5';
  }
  if (lowerName.includes('1980') && lowerName.includes('gas') && lowerName.includes('late')) {
    return '#7B8EF5';
  }
  if (lowerName.includes('old') && lowerName.includes('medium') && lowerName.includes('gas')) {
    return '#F6C568';
  }
  if (lowerName.includes('old') && lowerName.includes('electric') && lowerName.includes('apart')) {
    return '#004DA7';
  }
  if (lowerName.includes('modern') && lowerName.includes('medium') && lowerName.includes('elect')) {
    return '#A9DDB6';
  }
  if (lowerName.includes('modern') && lowerName.includes('medium') && lowerName.includes('gas')) {
    return '#89CD66';
  }
  if (lowerName.includes('post') && lowerName.includes('mix') && lowerName.includes('gas')) {
    return '#FE0000';
  }
  if (lowerName.includes('post') && lowerName.includes('gas') && lowerName.includes('-2')) {
    return '#FF7F7E';
  }
  
  return null;
}

// ===== RANDOM COLORS (COMMENTED OUT FOR TESTING) =====
// Generate random vibrant colors for archetypes
const ARCHETYPE_COLORS = [
  "#FF6B6B",
  "#4ECDC4",
  "#45B7D1",
  "#FFA07A",
  "#98D8C8",
  "#F7DC6F",
  "#BB8FCE",
  "#85C1E2",
  "#F8B88B",
  "#C39BD3",
  "#7DCEA0",
  "#FAD7A0",
  "#AED6F1",
  "#F5B7B1",
  "#D7BDE2",
  "#A2D9CE",
  "#F9E79F",
  "#D5DBDB",
  "#FADBD8",
  "#D1F2EB",
];

let colorIndex = 0;
export function getArchetypeColor(archetypeName?: string): string {
  // Try fixed colors first
  if (archetypeName) {
    const fixedColor = getFixedColor(archetypeName);
    if (fixedColor) {
      return fixedColor;
    }
  }
  
  // Fallback to random colors for unknown archetypes
  const color = ARCHETYPE_COLORS[colorIndex % ARCHETYPE_COLORS.length];
  colorIndex++;
  return color;
}

export function resetColorIndex() {
  colorIndex = 0;
}

// Map dimensions for EPSG:2157 (Irish Transverse Mercator)
export const MAP_SIZE = 2000;